import {AllocationState} from "@/api/types";

export class FactoryLoadingPlan {
    id: string
    code: string
    customerId: string
    customerAbbr: string
    shippingOrderId: string
    shippingOrderCode: string
    state: AllocationState
    remark: string
    createdAt: string
    containerTypeInfos: string[]
    unreleasedContainerTypeQuantity: number
    logisticsClerkId: string
    logisticsClerkName: string
    estimatedSailingSchedule: string
    billOfLadingCode: string
    customerCode?: string
    customerAbbreviation?: string
    combinedContainer: boolean
    sellerId: string
    companyCode: string;
    declaration: string;

    constructor(id?: string, code?: string, customerAbbreviation?: string, customerId?: string) {
        this.id = id;
        this.code = code;
        this.customerAbbr = customerAbbreviation;
        this.customerAbbreviation = customerAbbreviation;
        this.customerId = customerId;
    }
}

export class ContainerTypeInfo {
    id?: string
    containerType?: string
    containerNumber?: string
    sealNumber?: string
    loadingInOneOrMorePlaces?: boolean

    constructor(id?: string,
                containerType?: string,
                containerNumber?: string,
                sealNumber?: string,
                supplierName?: string,
                loadingInOneOrMorePlaces?: boolean) {
        this.id = id;
        this.containerType = containerType;
        this.containerNumber = containerNumber;
        this.sealNumber = sealNumber;
        this.loadingInOneOrMorePlaces = loadingInOneOrMorePlaces;
    }
}
